import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  InputAdornment,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  Search,
  Add,
  FormatListBulleted,
  CheckCircle,
  Cancel,
} from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export const SectionToolbar = ({
  searchTerm,
  setSearchTerm,
  handleModal,
  handleFilter,
  sectionsCount,
  activeSectionsCount,
  inactiveSectionsCount,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const onFilterSelect = (status) => {
    handleFilter(status);
    closeMenu();
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: 1,
        mb: 2,
        marginTop: "5px",
      }}
    >
      <Box sx={{ flexGrow: 1, marginLeft: "15px", marginRight: "9px" }}>
        <TextField
          placeholder="Buscar sección..."
          variant="outlined"
          fullWidth
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search fontSize="small" />
              </InputAdornment>
            ),
          }}
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          gap: 1,
          flexWrap: "wrap",
          justifyContent: { xs: "flex-start", md: "flex-end" },
          width: { xs: "100%", md: "auto" },
          mt: { xs: 1, md: 0 },
          marginRight: "15px",
          marginLeft: "15px",
        }}
      >
        <Button
          variant="contained"
          startIcon={<Add />}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            px: 1,
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            whiteSpace: "nowrap",
            flexGrow: { xs: 1, md: 0 },
          }}
          onClick={() => handleModal("add", true)}
        >
          Agregar Sección
        </Button>

        <Tooltip title="Información del documento">
          <Button
            variant="outlined"
            color="primary"
            onClick={openMenu}
            sx={{
              minWidth: "60px",
              borderRadius: "8px",
              mr: { xs: "25px", md: 0 },
            }}
          >
            <MoreVertIcon />
          </Button>
        </Tooltip>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={closeMenu}
          PaperProps={{
            elevation: 3,
            sx: {
              borderRadius: "14px",
              minWidth: 320,
              mt: 1,
              overflow: "hidden",
            },
          }}
        >
          <MenuItem onClick={() => onFilterSelect(undefined)}>
            <ListItemIcon>
              <FormatListBulleted color="info" />
            </ListItemIcon>
            <ListItemText
              primary="Total de Secciones"
              secondary={sectionsCount}
            />
          </MenuItem>

          <MenuItem onClick={() => onFilterSelect(1)}>
            <ListItemIcon>
              <CheckCircle color="success" />
            </ListItemIcon>
            <ListItemText
              primary="Secciones Activas"
              secondary={activeSectionsCount}
            />
          </MenuItem>

          <MenuItem onClick={() => onFilterSelect(0)}>
            <ListItemIcon>
              <Cancel color="error" />
            </ListItemIcon>
            <ListItemText
              primary="Secciones Inactivas"
              secondary={inactiveSectionsCount}
            />
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};
